import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: TextInputComponent,
    },
  ],
})
export class TextInputComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() type = 'text';
  @Input() enablePasswordToggle = false;
  @Input() id = '';
  @Input() name = '';
  @Input() placeholder = '';
  @Input() ariaLabel = '';
  @Input() errorMessage = '';
  @Input() showError = false;
  @Input() autocomplete = 'off';
  @Input() inputClass = '';
  @Input() min: string | number | null = null;
  @Input() max: string | number | null = null;
  @Input() step: string | number | null = null;
  @Input() inputMode = '';
  @Input() startIcon = '';
  @Input() startIconAlt = 'start icon';
  @Input() endIcon = '';
  @Input() endIconAlt = 'end icon';

  value = '';
  disabled = false;
  isPasswordVisible = false;

  onChange = (value: string) => { };
  onTouched = () => { };

  writeValue(value: string | null): void {
    this.value = value ?? '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  get resolvedType(): string {
    if (this.enablePasswordToggle && this.type === 'password') {
      return this.isPasswordVisible ? 'text' : 'password';
    }

    return this.type;
  }

  togglePasswordVisibility(): void {
    if (this.disabled) {
      return;
    }

    this.isPasswordVisible = !this.isPasswordVisible;
  }

  inputChanged(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.value = value;
    this.onChange(value);
  }
}
